<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="500" scrollable>
			<v-card>
				<v-card-title class="text-h6">Form Bank Perusahaan</v-card-title>
				<v-card-text>
					<v-row>
						<v-col cols="12" sm="12" md="12">
							<v-autocomplete item-text="bank_name" item-value="bank_name" outlined dense v-model="params.bank" :items="optionBank" label="Bank" no-data-text="Tidak ada data yang sesuai" @focus="() => error_validation.bank = ''" :error-messages="error_validation.bank"></v-autocomplete>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Nama Pemilik" v-model="params.name" @focus="() => error_validation.name = ''" :error-messages="error_validation.name"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="No. Rekening" v-model="params.no" @focus="() => error_validation.no = ''" :error-messages="error_validation.no"></v-text-field>
						</v-col>
						<v-col cols="12" sm="12" md="12">
							<v-text-field outlined dense label="Cabang" v-model="params.branch" @focus="() => error_validation.branch = ''" :error-messages="error_validation.branch"></v-text-field>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideModal">Batal</v-btn>
					<v-btn color="primary" depressed class="text-capitalize" @click="simpan">Simpan</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
const list_status = [{
	value: '1',
	text: 'Aktif'
}, {
	value: '0',
	text: 'Tidak Aktif'
}];

export default {
	data () {
		return {
			params: {
				bank: '',
				name: '',
				no: '',
				branch: '',
				is_active: '',
				id: '',
			},
			list_status: list_status,
			status: '',
			dialog: false,
		}
	},
	props: {
	},
	computed: {
		...mapState(['error_validation']),
		...mapState('ecommerceCommon', ['optionBank']),
	},
	methods: {
		...mapMutations(['validationError']),

		showModal() {
			this.dialog = true
		},
		hideModal() {
			this.dialog = false
		},
		defineParams(data) {
			this.validationError({})
			this.params.bank = data.bank_account_bank
			this.params.name = data.bank_account_name
			this.params.no = data.bank_account_no
			this.params.branch = data.bank_account_branch
			this.params.is_active = data.bank_account_is_active
			this.params.id = data.bank_account_id
		},
		simpan() {
			this.$emit('save', this.params)
		}
	},
	watch: {
	},
	created() {
	}
}
</script>
